import { EmbeddedCarousel } from 'src/components/embedded-carousel';

export default EmbeddedCarousel;
